<template>
  <div class="TableHeader d-flex justify-content-between mb-2" :class="{mobileResponsiveHeader}">
    <div class="d-flex align-items-center card-title-wrapper">
      <h3 class="card-title mr-2">
        {{ title }}
      </h3>
      <slot name="after-title"></slot>
    </div>
    <div class="d-flex table-slots align-items-center">
      <slot
        name="header-buttons-before"

        :showButton="showButton"
        :refetch="refetch"
      ></slot>

      <!-- <FormCheckbox v-if='!alwaysShowMultiSelectCheckbox && selectMultipleValue'
        type='button'
        id="multiple-select-toggle"
        class="btn btn-light header-btn"
        :class="{active: selecting}"

        v-model="selecting"
      >
        <template #before>
          <svg xmlns="http://www.w3.org/2000/svg" class="button-icon" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16" />
          </svg>

          {{ selectMultipleValue }}
        </template>
      </FormCheckbox> -->
      <div v-if="!removeColumnConfiguration">
        <button class="btn"
          type='button'
          @click="$emit('customize-layout')"
        >
          Kolommen

          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </button>
      </div>
      <div v-else></div>
      <div v-if="exportEndpoint && csvName">
        <button class="mx-2 d-flex align-items-center py-2" @click="exportTable">
          Export CSV

          <svg class="ml-2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 48 48">
            <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
              <path d="M9.5,10.5v2a1,1,0,0,1-1,1h-7a1,1,0,0,1-1-1V1.5a1,1,0,0,1,1-1h7a1,1,0,0,1,1,1v2" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
              <line x1="6.5" y1="7" x2="13.5" y2="7" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
              <polyline points="11.5 5 13.5 7 11.5 9" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></polyline>
            </g></g>
          </svg>
        </button>
      </div>

      <slot
        name="header-buttons-after"
        :refetch="refetch"
      ></slot>

      <div v-show="!removeColumnConfiguration">
        <button class="btn mx-2"
          type='button'
          @click="$emit('setting-layout')"
        >
          Instellingen

          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import FormCheckbox from '../../Inputs/FormCheckbox.vue'

import mom from "moment"

function downloadCSV(csv, filename) {
  let csvFile;
	let downloadLink;

	csvFile = new Blob([csv], {type:"text/csv"});
	downloadLink = document.createElement("a");
	downloadLink.download = filename;
	downloadLink.href = window.URL.createObjectURL(csvFile);
	downloadLink.style.display = "none";
	document.body.appendChild(downloadLink);
	downloadLink.click();
}

export default {
  components: {
    FormCheckbox,
  },
  props: {
    alwaysShowMultiSelectCheckbox: Boolean,
    mobileResponsiveHeader: Boolean,
    removeColumnConfiguration: Boolean,

    value: {
      type: Boolean,
      required: false,
    },

    selectMultipleValue: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    showButton: {
      type: [Boolean, Number],
      required: false,
    },
    refetch: {
      type: Function,
      required: false,
    },

    deliveryExport: Boolean,
    exportEndpoint: String,
    exportParams: Object,
    csvName: String,
    exportEndpointType: {
      type: String,
      default: "get",
    },
  },
  created() {
    if (this.alwaysShowMultiSelectCheckbox) {
      this.$emit("input", true)
    }
  },
  data() {
    return {
      selecting: this.value || false,
    }
  },
  methods: {
    async exportTable() {
      if (this.deliveryExport) {
        this.$handlePromise(async () => {
          const res = await this.axios.get(`/api/deliveries`, {
            page_size: 100000,
          })
          const deliveries = res.data.results

          const {data} = await this.axios.post(`/api/delivery-exports`, {deliveries: deliveries.map(item => item.id)})
          downloadCSV(
            data,
            (this.csvName + mom().format('YYYY-MM-DD')) + `.csv`
          )

          this.$success("Aanvulling export succes!")
          this.refetch()
        })
      } else {
        this.$handlePromise(async () => {
          const type = this.exportEndpointType
          const params = type === 'get' ? { params: this.exportParams } : this.exportParams
          
          const {data} = await this.axios[type](this.exportEndpoint, params)
          downloadCSV(data, this.csvName + ".csv")
        })
      }
    },
  },
  watch: {
    selecting(val) {
      this.$emit("input", val)
    },
    value(val) {
      this.selecting = val

      if (this.alwaysShowMultiSelectCheckbox) {
        this.$emit("input", true)
      }
    },
  },
}

</script>

<style scoped>

.header-btn {
  margin-right: 8px;
}

.card-title-wrapper h3, .card-title-wrapper button {
  font-weight: 700 !important;
}

.card-title {
  margin-top: 10px;
  margin-bottom: 10px;
}

.btn:hover {
  color: var(--primary);
}

@media (max-width: 600px) {
  .TableHeader.mobileResponsiveHeader {
    flex-direction: column;
  }

  .TableHeader.mobileResponsiveHeader > div {
    width: 100%;
  }

  .table-slots {
    flex-direction: row-reverse;
  }
}

</style>
